import React from 'react';
import {
    Grid,
    Tooltip,
} from '@material-ui/core';
import './EmployeeDataviewTooltip.scss';

/**
 * @param {{
 * employeeName : string,
 * dataviewAttributes : ApiManager.IDataviewSearch[],
 * }} props
 */
function EmployeeDataviewTooltip(props) {
    const { employeeName, dataviewAttributes } = props;
    return (
        <Tooltip
            arrow
            enterDelay={500}
            leaveDelay={250}
            enterNextDelay={500}
            classes={{ tooltip: 'edt-tooltip' }}
            placement="top"
            title={(
                <div>
                    <div className="edt-popover-title">
                        {employeeName}
                    </div>
                    <Grid container>
                        {dataviewAttributes.map((field) => (
                            <React.Fragment key={`${employeeName}-${field.key}`}>
                                <Grid
                                    item
                                    xs={6}
                                    className="edt-popover-dataview-field"
                                >
                                    {field.label}
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                    className="edt-popover-dataview-value"
                                >
                                    {field.rawValue}
                                </Grid>
                            </React.Fragment>
                        ))}
                    </Grid>
                </div>
            )}
        >
            <span>{employeeName}</span>
        </Tooltip>
    );
}

export default EmployeeDataviewTooltip;
